import { render, staticRenderFns } from "./UserRoleItem.vue?vue&type=template&id=61e64488&"
import script from "./UserRoleItem.vue?vue&type=script&lang=ts&"
export * from "./UserRoleItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports